export interface TimeInputProps {
  className?: string;
  isFullWidth?: boolean;
  onSelectTime?: (hour: number, minute: number, isAmPmToggle: boolean, isFromDropdown: boolean) => void;
  dropdownID: string;
  shouldDisplayIcon?: boolean;
  defaultSelectedDateTime?: Date;
  onTimeInputFocusCallback?: () => void;
  onTimeInputBlurCallback?: (hour: number, minute: number) => void;
  isInErrorState?: boolean;
  onClickSelector?: () => void;
  minSelectableDateTime?: Date;
}

export enum DayNightSelector {
  AM = 'AM',
  PM = 'PM',
}

export interface ParsedTimeSlot {
  hour12: number;
  minute: number;
  dayNight: DayNightSelector;
}
